import { Skeleton } from '@chakra-ui/react';
import { Image } from 'components/v4';

function LoginLogo({ isLoading, src, imageFileType }) {
    return isLoading ? (
        <Skeleton w="100%" h="76px" isLoaded={!isLoading} fadeDuration={1} />
    ) : imageFileType === 'png' ? (
        <Image
            alt="Domain Logo"
            display="block"
            maxWidth="300px"
            maxHeight="150px"
            margin="0 auto"
            src={src}
        />
    ) : (
        imageFileType === 'svg' && (
            <object
                alt="Domain Logo"
                style={{
                    display: 'block',
                    maxWidth: '300px',
                    maxHeight: '150px',
                    margin: '0 auto',
                }}
                data={src}
                type="image/svg+xml">
                Domain Logo
            </object>
        )
    );
}

export { LoginLogo };
